import { apiCall, type ApiClientConfig } from "@playbookai/api-clients";

export type AdoptionPeriodDays = 7 | 30 | 90;
export type AdoptionModuleId = "solve" | "vsm" | "hoshin" | "lama";

export interface AdoptionPoint {
  readonly date: string;
  readonly count: number;
}

export interface AdoptionModuleReading {
  readonly id: AdoptionModuleId;
  readonly label: string;
  readonly description: string;
  readonly status: "ready" | "unavailable";
  readonly total: number | null;
  readonly previousTotal: number | null;
  readonly changePercent: number | null;
  readonly points: readonly AdoptionPoint[];
}

export interface AdoptionSummary {
  readonly window: {
    readonly days: AdoptionPeriodDays;
    readonly from: string;
    readonly to: string;
    readonly generatedAt: string;
  };
  readonly totalActivity: number | null;
  readonly previousTotalActivity: number | null;
  readonly modules: readonly AdoptionModuleReading[];
}

export const adoptionQueryKey = (
  tenantId: string | undefined,
  days: AdoptionPeriodDays,
) => ["admin", "adoption", tenantId ?? "no-tenant", days] as const;

export function getAdoptionSummary(
  config: ApiClientConfig,
  days: AdoptionPeriodDays,
  signal?: AbortSignal,
): Promise<AdoptionSummary> {
  return apiCall<AdoptionSummary>(
    config,
    "GET",
    "/v1/admin/adoption",
    undefined,
    { days },
    signal,
  );
}
